<template>
  <div class="user-themes pb-16">
    <SettingsHotkeys />
  </div>
</template>

<script>
import SettingsHotkeys from '@/components/Dialogs/UserSettingsDialog/SettingsHotkeys'

export default {
  name: 'UserThemes',

  components: {
    SettingsHotkeys,
  },
  data() {
    return {}
  },
}
</script>
